import React from "react";

interface ContextType {
  overrideQuestionSlideTitle: (newTitle: string) => void;
  overrideQuestionSlideDesc: (newDesc: string) => void;
  overrideQuestionSlideAnswerDesc: (newDesc: string) => void;
}

export const RenderTemplateContext = React.createContext<ContextType>({
  overrideQuestionSlideTitle: (newTitle) => null,
  overrideQuestionSlideDesc: (newDesc) => null,
  overrideQuestionSlideAnswerDesc: (newDesc) => null,
});

export const RenderTemplateProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ContextType;
}) => {
  return <RenderTemplateContext.Provider value={value}>{children}</RenderTemplateContext.Provider>;
};
